import { useFavoriteServiceState, useMegaMenuQuery, ViewPoint } from '@kc-console/context';
/**
 * 콘솔 메뉴를 메가메뉴 레이아웃에 맞게 재정의하여 제공하는 훅입니다.
 * view point가 megamenu에 해당되지 않는 서비스 혹은 카테고리는 기본적으로는 필터링되어 표시되지 않습니다.
 *
 * @param isSearchable - true일 경우 ViewPoint.SEARCH를 포함하는 서비스도 필터링에 포함.
 */

interface useRefinedConsoleMenuStateParams {
  isSearchable?: boolean;
}

export const useRefinedConsoleMenuState = ({
  isSearchable = false,
}: useRefinedConsoleMenuStateParams = {}) => {
  const { data: categories = [] } = useMegaMenuQuery();
  const { data: favoriteServiceList = [] } = useFavoriteServiceState();

  const aggregatedServices = categories
    .map(category => {
      const updatedCategory = {
        ...category,
        services: category.services
          .filter(service => {
            const hasMegamenu = service.viewPoint?.includes(ViewPoint.MEGAMENU);
            const hasSearch = isSearchable && service.viewPoint?.includes(ViewPoint.SEARCH);
            return hasMegamenu || hasSearch;
          })
          .map(service => {
            return {
              ...service,
              isFavorite: !!favoriteServiceList.find(fs => fs.keyword === service.keyword),
            };
          }),
      };
      return updatedCategory;
    })
    .filter(category => category.services.length > 0);

  return { allServices: aggregatedServices };
};
